// Auto generated file, do not manually modify!
// com.hotpads.rewardsapi.client.enums.RewardsApiTransactionType

export enum RewardsApiTransactionType {
  ENROLLMENT_BONUS = 'ENROLLMENT_BONUS',
  MANUAL_CREDIT = 'MANUAL_CREDIT',
  MANUAL_DEBIT = 'MANUAL_DEBIT',
  RENT_PAYMENT = 'RENT_PAYMENT',
  RENT_PAYMENT_REFUNDED = 'RENT_PAYMENT_REFUNDED',
}

export const RewardsApiTransactionType_values = [
  RewardsApiTransactionType.ENROLLMENT_BONUS,
  RewardsApiTransactionType.MANUAL_CREDIT,
  RewardsApiTransactionType.MANUAL_DEBIT,
  RewardsApiTransactionType.RENT_PAYMENT,
  RewardsApiTransactionType.RENT_PAYMENT_REFUNDED,
] as const;
